import { consoleApiSlice } from "./consoleApiSlice";

export const agentSchedulerApiSlice = consoleApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAgentSchedules: builder.query({
      query: () => ({ url: "/agent-scheduler/schedules", method: "GET" }),
      providesTags: ["AgentSchedules"],
    }),
  }),
});

export const { useGetAgentSchedulesQuery } = agentSchedulerApiSlice;
